import _ from "lodash";
import utils from '@k4connect/project-camelot-utils';

class Community {
	// CASL subject type detection
	static get modelName() {
		return "Community";
	}

	constructor({ _id, _operatorId, _provisionId, _name, _logo, _timezone }) {
		this.id = _id;
		this.legacyId = utils.guidToId(_id);
		this.operator  = _operatorId;
		this.identifier = _provisionId;
		this.name = _name;

		this.iconUrl = _logo;

		this.data = {
			timezone: _timezone
		};
	}
}

export function createCommunity(item) {
	return Object.freeze(new Community(item));
}
